import { useMemo } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { styled } from '@mui/material/styles';
import ContactFieldsSettings from '@features/ContactFieldsSettings';
import { MultiSelectLabels } from '@components/MultiSelectLabels';
import { useTranslation } from '@hooks';
import { LabelType } from '@constants/labels';

const ContactFields = styled('div')({
    marginBottom: 16,
});

const CollectInformationBlock = ({ labels }) => {
    const { control, setValue, getValues } = useFormContext();
    const { t } = useTranslation();

    const labelsOptions = useMemo(() => labels.map(item => ({ value: item.id, label: item.name })), [labels]);

    return (
        <div style={{ paddingBottom: 16 }}>
            <ContactFields>
                <ContactFieldsSettings requireIdentifyingField />
            </ContactFields>
            <Controller
                control={control}
                name="labels"
                render={({ field, ref }) => (
                    <MultiSelectLabels
                        {...field}
                        ref={ref}
                        onChange={value => {
                            setValue('labels', value, { shouldDirty: true });
                        }}
                        options={labelsOptions}
                        label={t('common.labels')}
                        fullWidth
                        type={LabelType.Contact}
                        hideNpsLabels
                        onCreateCallback={newLabel => {
                            const values = getValues();
                            setValue('labels', [...values.labels, newLabel], {
                                shouldDirty: true,
                            });
                        }}
                    />
                )}
            />
        </div>
    );
};

export default CollectInformationBlock;
